<app-ice-stepper
  #stepper
  [hasCustomNavigation]="false"
  [interactedSteps]="formGroupDirective.form.controls.interactedSteps?.value || []"
  [selectedIndex]="selectedStep() || 0"
  (isFinished)="finishSubscription.emit()"
  (selectionChange)="stepperOnChange($event)"
>
  <cdk-step label="Abonnement" [completed]="product?.offering?.id" [hasError]="chooseSubscriptionHasError">
    <div class="order-builder-component">
      <app-order-builder-step
        [allowedOfferings]="offerings"
        [canSellMobilePhone]="canSellMobilePhone"
        [isEquipmentUpgradeEnabled]="isEquipmentUpgradeEnabled"
        [product]="product"
        [showOfferings]="selectedStep() === 0"
        (isInvalid)="setChooseSubscriptionHasError($event)"
        (productChanged)="onProductChange($event)"
        (sponsorSelected)="onSponsorSelected($event)"
        (sponsorTypeSelected)="onSponsorTypeSelected($event)"
      />
    </div>
    <div class="step-navigation">
      <app-ice-button color="secondary" testId="voice-subscription-next-button" (click)="stepper.next()">
        Neste
      </app-ice-button>
    </div>
  </cdk-step>
  <cdk-step
    label="Nummer"
    [completed]="!numberChooserHasError"
    [hasError]="numberChooserHasError || formGroupDirective.form.pending"
  >
    <div class="order-builder-component">
      <app-number-chooser-step
        [product]="product"
        (isInvalid)="setNumberChooserHasError($event)"
        (updatePhoneNumber)="onUpdatePhoneNumber($event)"
      />
    </div>
    <div class="step-navigation">
      <app-ice-button color="outlined" testId="subsription-stepper-back-button" (click)="stepper.previous()">
        Tilbake
      </app-ice-button>
      <app-ice-button color="secondary" testId="choose-number-next-button" (click)="stepper.next()">Neste</app-ice-button>
    </div>
  </cdk-step>
  <cdk-step label="Bruker" [completed]="!userHasError" [hasError]="userHasError">
    <div class="order-builder-component">
      <app-user-definer-step
        groupName="user"
        [hasInteractedWithStep]="hasInteractedWithStep(2)"
        [lowerAgeLimit]="product.offering?.lowerAgeLimit"
        [productId]="product.id"
        [showUser]="selectedStep() === 2"
        [subscriber]="product.subscriber"
        [upperAgeLimit]="product.offering?.upperAgeLimit"
        [voiceSubscriptionType]="product.offering?.subscriptionType"
        (isInvalid)="setUserHasError($event)"
        (updateSubscriber)="updateSubscriberInState($event)"
      />
    </div>
    <div class="step-navigation">
      <app-ice-button color="outlined" testId="subsription-stepper-back-button" (click)="stepper.previous()">
        Tilbake
      </app-ice-button>
      <app-ice-button color="secondary" testId="define-user-next-button" (click)="stepper.next()">Neste</app-ice-button>
    </div>
  </cdk-step>
  <cdk-step label="Tilleggstjenester" [completed]="!additionalServicesHasError" [hasError]="additionalServicesHasError">
    <app-additional-services-step
      [product]="product"
      [showServices]="selectedStep() === 3"
      (isInvalid)="setAdditionalServicesHasError($event)"
    />
    <div class="step-navigation">
      <app-ice-button color="outlined" testId="subsription-stepper-back-button" (click)="stepper.previous()">
        Tilbake
      </app-ice-button>
      <app-ice-button color="primary" testId="additional-services-finished-button" (click)="finishSubscription.emit()">
        Ferdig
      </app-ice-button>
    </div>
  </cdk-step>
</app-ice-stepper>
